import { ICS2Notification, ICS2NotificationError } from 'store/declarations/eu/ics2/ics2-notification';
import Ics2ActionRequiredNotification from './Ics2ActionRequiredNotification';
import RawData from '../../RawData';
import Ics2DeclarationErrors from '../../declaration-errors/ics2/Ics2DeclarationErrors';

type DrawerConfig = {
    component: React.ComponentType<any>;
    props?: Record<string, any>;
    drawerType: 'showErrors' | 'requireAction';
};

type Args = {
    /**
     * The newest ICS2 message that still asks the trader to do something, which is not necessarily
     * the newest notification overall. Derived from the message type, because the backend never
     * sets `Declaration.actionRequired` for ICS2.
     */
    actionRequiredNotification?: ICS2Notification;
    latestNotification?: ICS2Notification;
    errors?: ICS2NotificationError[];
    showRawData?: boolean;
};

export const resolveIcs2Drawer = ({
    actionRequiredNotification,
    latestNotification,
    errors,
    showRawData,
}: Args): DrawerConfig => {
    if (actionRequiredNotification) {
        return {
            component: Ics2ActionRequiredNotification,
            drawerType: 'requireAction',
            props: { latestNotification: actionRequiredNotification },
        };
    }

    if (errors?.length) {
        return {
            component: Ics2DeclarationErrors,
            drawerType: 'showErrors',
            props: { errors, showRawData, showErrorCards: true },
        };
    }

    return {
        component: RawData,
        drawerType: 'showErrors',
        props: { notification: latestNotification },
    };
};
